//init firebase
import { auth } from "../firebase/config"
import { signOut } from "firebase/auth"
import { useAuthContext } from "./useAuthContext"
import { Notification } from "../components/Notification"
import { useNavigate } from "react-router-dom"
import useAdminModeStore from "../store/Admin/adminMode"

export const useLogout = () => {
  const { dispatch } = useAuthContext()
  const navigate = useNavigate()
  const { setAdminMode } = useAdminModeStore()

  const logout = () => {
    signOut(auth)
      .then(() => {
        dispatch({ type: "LOGOUT" })
        Notification("warning", "Logged out", "You have logged out!")
      })
      .then(() => {
        navigate("/login")
        setAdminMode(false)
      })
      .catch((err) => {
        console.log(err.message)
        Notification("error", "Error while logging out", err.message)
      })
  }

  return { logout }
}
